import React from 'react';
import {SwiperSlide} from 'swiper/react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {AppButton} from '@/components/Button';
import RemoteImage from '@/components/Image/RemoteImage';
import {ADVANCED_DIAGNOSTICS_DAMAGE_SELECT_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {getLocalizedStrings} from '@/services/localization/localizationService';

import advanceDiagnosticService from '../advanceDiagnosticService';

const AdvancedDiagnosticDamageSlides = ({carouselData}) => {
    const localizedStrings = getLocalizedStrings();

    const onOptionButtonClick = (screenName, errorCode, isHolder, amplitudeQuestionnairePage) => {
        amplitudeADTracking.trackADQuestionnaireSelectClick(amplitudeQuestionnairePage);
        googleAnalyticsService.trackAdQuestionnaireSelectClick(amplitudeQuestionnairePage);
        advanceDiagnosticService.setInferenceCodeAndRedirect(errorCode, isHolder, screenName);
    };

    return carouselData.map((option, i) => {
        const {amplitudeQuestionnairePage, imageMedia, title, description, nextStep, errorCode, isHolder} = option;

        return (
            <SwiperSlide key={i}>
                <div className='flex h-full w-full max-w-[320px] flex-col rounded-xl bg-primary-dark-15 text-primary ml:max-w-[370px] ml:bg-romance'>
                    <RemoteImage
                        className='h-[176px] w-full rounded-t-xl bg-center object-cover ml:h-[208px] ml:rounded-t-none'
                        imageMedia={imageMedia}
                    />
                    <div className='flex h-full flex-col items-center justify-between rounded-b-xl bg-primary-dark-5 px-4 py-6 text-center ml:rounded-b-[4px] ml:bg-romance'>
                        <h2 className='mb-3 text-20'>{localizedStrings[title]}</h2>
                        <p>{localizedStrings[description]}</p>
                        <AppButton
                            secondary
                            light
                            onClick={() =>
                                onOptionButtonClick(nextStep, errorCode, isHolder, amplitudeQuestionnairePage)
                            }
                            className='mt-6 w-full ml:mt-8'
                            aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_DAMAGE_SELECT_BUTTON_ARIA_LABEL)}
                        >
                            <AemEditableText pageName={routePaths.ADVANCE_DIAGNOSTIC} itemName='damageselectbutton' />
                        </AppButton>
                    </div>
                </div>
            </SwiperSlide>
        );
    });
};

export default AdvancedDiagnosticDamageSlides;
